function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { MultiSelectFilterPicker } from 'seagull';
import RadioFilterPicker from "../RadioFilterPicker/RadioFilterPicker";
import DateRangeWithPresets from "../DateRangeWithPresets/DateRangeWithPresets";
import DateRangeFilterPicker from "../DateRangeFilterPicker/DateRangeFilterPicker";
import { SearchFilterType } from "../types";
const Filter = _ref => {
  let {
    testIdPrefix,
    label,
    filter,
    filterConfig,
    selectedFilter,
    onChange,
    onRemove,
    onInputBlur,
    onInputFocus
  } = _ref;
  const getFilterPicker = () => {
    var _filterConfig$options;
    switch (filterConfig.type) {
      case SearchFilterType.DateRangeFilter:
        return /*#__PURE__*/React.createElement(DateRangeFilterPicker, _extends({
          value: selectedFilter,
          onChange: onChange,
          onRemove: onRemove,
          "data-testid": "".concat(testIdPrefix, "-filter-").concat(filter),
          label: label,
          onInputFocus: onInputFocus,
          onInputBlur: onInputBlur,
          startOpen: !!selectedFilter && filterConfig.removable
        }, filterConfig));
      case SearchFilterType.MultiSelectFilter:
        return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
          withSearchbox: filterConfig.withSearchbox,
          removable: filterConfig.removable,
          value: selectedFilter,
          "data-testid": "".concat(testIdPrefix, "-filter-").concat(filter),
          title: filterConfig.title || label,
          options: ((_filterConfig$options = filterConfig.options) === null || _filterConfig$options === void 0 ? void 0 : _filterConfig$options.map(option => typeof option === 'string' ? {
            value: option,
            label: option
          } : option)) || [],
          label: label,
          onChange: onChange,
          onRemove: onRemove,
          onInputFocus: onInputFocus,
          startOpen: !!selectedFilter && filterConfig.removable,
          onInputBlur: onInputBlur,
          selectAllByDefault: filterConfig.selectAllByDefault
        });
      case SearchFilterType.DateRangeWithPresets:
        return /*#__PURE__*/React.createElement(DateRangeWithPresets, {
          now: new Date(),
          startDate: selectedFilter.dateRange[0],
          endDate: selectedFilter.dateRange[1],
          dataRangeOption: selectedFilter.dateRangeOption,
          onApply: (dataRange, startDate, endDate) => {
            onChange({
              dateRange: [startDate, endDate],
              dateRangeOption: dataRange
            });
          }
        });
      case SearchFilterType.RadioFilter:
        return /*#__PURE__*/React.createElement(RadioFilterPicker, {
          selectedValue: selectedFilter,
          defaultLabel: label,
          title: filterConfig.title || label,
          testId: "".concat(testIdPrefix, "-filter-").concat(filter),
          onApply: aggregate => onChange(aggregate),
          setValue: aggregate => onChange(aggregate)
        });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(testIdPrefix, "-filter-").concat(filter)
  }, getFilterPicker());
};
export default Filter;